import { readRequest, updateRequest } from "../../web";

const locationCamerasURL = "/api/location/cameras";
const sensorEventURL = "/api/sensor-event-logs";

export function saveCameras(locationId: number, cameraListData: any) {
    return updateRequest<any, null>(locationCamerasURL, {
        LocationId: locationId,
        LocationCamerasDetails: cameraListData,
    });
}

export function getCamerasById(locationId: number) {
    return readRequest<any>(
        `${locationCamerasURL}/by-location?locationId=${locationId}`
    );
}

export function getSensorEventsById(locationId: number) {
    return readRequest<any>(
        `${sensorEventURL}/by-location?locationId=${locationId}`
    );
}
